import { Component, Input, OnInit, OnChanges, SimpleChanges, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatAccordion } from '@angular/material/expansion';

export interface ClauseEditResult {
  clause_uid: string;
  instruction: string;
  base_version: number;
  company_id: string;
}

interface Clause {
  id: string;
  title: string;
  content: string;
  text: string;
}

@Component({
  selector: 'app-clause-edit-modal',
  templateUrl: './clause-edit-modal.component.html',
  styleUrls: ['./clause-edit-modal.component.scss']
})
export class ClauseEditModalComponent implements OnInit, OnChanges {
  @Input() versionData!: any[];
  @Input() baseVersion: number = 0;
  @Input() companyId: string = '';
  @Input() isLoading = true;
  @Output() dataChanged = new EventEmitter<any>();

  @ViewChild(MatAccordion) accordion!: MatAccordion;

  clauses: Clause[] = [];
  selectedIndex: number = -1;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.isLoading == false && (!this.versionData || !Array.isArray(this.versionData))) {
      this.activeModal.dismiss('invalid-data');
      return;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['versionData'] && Array.isArray(this.versionData)) {
      this.clauses = this.createClausesFromData(this.versionData);
	  console.log(this.clauses)
    }
  }

  openAll() {
    if (this.accordion) {
      this.accordion.openAll();
    }
  }

  closeAll() {
    if (this.accordion) {
      this.accordion.closeAll();
    }
  }

  private createClausesFromData(data: any[]): Clause[] {
    return data.map((clause, index) => {
      if (Array.isArray(clause) && clause.length >= 2) {
        return {
          id: clause[0],
          title: clause[1] || `Cláusula ${index + 1}`,
          content: clause[2] || `Cláusula ${index + 2}`,
		  text:''
        };
      } else {
        return {
          id: clause.id || `clause_${index}`,
          title: clause.title || `Cláusula ${index + 1}`,
          content: clause.text || `Cláusula ${index + 2}`,
		  text:''
        };
      }
    });
  }

  selectClause(index: number) {
    this.selectedIndex = index;
  }

  onSaveChanges() {
    this.isLoading = true;
    const selectedClause = this.clauses[this.selectedIndex];

    const result: ClauseEditResult = {
      clause_uid: selectedClause.id,
      instruction: selectedClause.text,
      base_version: this.baseVersion,
      company_id: this.companyId
    };

    this.dataChanged.emit(result);
  }

  onCancel() {
    this.activeModal.dismiss('cancel');
  }
}